module.exports = __webpack_public_path__ + "static/media/uncle-wong-logo.ae7f16fa.gif";